// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import darkMode from "./darkMode";
import progressBar from "./progressBar";
import scrollReveal from "./scrollReveal";
import lightbox from "./lightbox";

menuOpen();
infiniteScroll();
darkMode();
progressBar();
scrollReveal();
lightbox();